if (!customElements.get('bezelor-bundle-three')) {
  customElements.define('bezelor-bundle-three', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.picks = new Map();
      this.labels = JSON.parse(this.querySelector('[data-bundle-labels]').textContent);
      this.cards = [...this.querySelectorAll('[data-product]')];
      this.submitButton = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style: 'currency', currency: this.dataset.currency || 'GBP'});
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-variant]')) return;
        const card = event.target.closest('[data-product]');
        const option = event.target.selectedOptions[0];
        card.querySelector('[data-regular-price]').textContent = option.dataset.money;
        card.querySelector('[data-bundle-price]').textContent = option.dataset.bundleMoney;
        const img = card.querySelector('.bz-bundle__img');
        if (img && option.dataset.image) { img.removeAttribute('srcset'); img.src = option.dataset.image; }
        if (this.picks.has(card.dataset.product)) this.picks.set(card.dataset.product, this.readCard(card));
        this.render();
      });
      this.addEventListener('click', event => {
        const pick = event.target.closest('[data-pick]');
        const remove = event.target.closest('[data-remove]');
        if (this.busy) return;
        if (pick) {
          const card = pick.closest('[data-product]');
          const id = card.dataset.product;
          if (this.picks.has(id)) this.picks.delete(id);
          else if (this.picks.size < 3) this.picks.set(id, this.readCard(card));
          else { this.status.textContent = this.labels.limit; return; }
          this.status.textContent = '';
          this.render();
        } else if (remove) { this.picks.delete(remove.dataset.remove); this.render(); }
        else if (event.target.closest('[data-submit]')) this.addBundle();
        else if (event.target.closest('[data-prev],[data-next]')) {
          const track = this.querySelector('.bz-bundle__list');
          const next = event.target.closest('[data-next]');
          const distance = this.cards[0]?.getBoundingClientRect().width + 16 || 250;
          track.scrollBy({left: (next ? 1 : -1) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
      });
      this.render();
    }
    readCard(card) {
      const option = card.querySelector('[data-variant]').selectedOptions[0];
      return {id: option.value, price: Number(option.dataset.price), title: card.querySelector('h3').textContent.trim(), image: card.querySelector('img')?.src, variant: option.textContent.trim()};
    }
    render() {
      const count = this.picks.size;
      this.querySelector('[data-count]').textContent = count + ' / 3';
      this.cards.forEach(card => {
        const selected = this.picks.has(card.dataset.product);
        card.classList.toggle('is-selected', selected);
        const button = card.querySelector('[data-pick]');
        button.setAttribute('aria-pressed', String(selected));
        if (!button.disabled) button.textContent = selected ? this.labels.selected : this.labels.select;
      });
      const slots = this.querySelector('[data-slots]');
      slots.replaceChildren();
      [...this.picks.entries()].forEach(([id, item]) => {
        const li = document.createElement('li'); li.className = 'filled';
        if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.width = 42; img.height = 52; li.append(img); }
        const p = document.createElement('p'); p.textContent = item.title; p.title = item.title + ' — ' + item.variant; li.append(p);
        const button = document.createElement('button'); button.type = 'button'; button.dataset.remove = id; button.textContent = '×'; button.setAttribute('aria-label', this.labels.remove + ' ' + item.title); li.append(button); slots.append(li);
      });
      for (let i=count; i<3; i++) { const li=document.createElement('li'); const span=document.createElement('span'); span.textContent=String(i+1); li.append(span,document.createTextNode(this.labels.choose)); slots.append(li); }
      const items = [...this.picks.values()];
      const before = items.reduce((sum,item)=>sum+item.price,0);
      const after = items.reduce((sum,item)=>sum+item.price-Math.floor(item.price*.2+1e-7),0);
      this.querySelector('[data-total-before]').hidden = count!==3;
      this.querySelector('[data-total-before]').textContent = this.format.format(before/100);
      this.querySelector('[data-total]').textContent = count===3 ? this.format.format(after/100) : '—';
      this.querySelector('[data-savings]').textContent = count===3 ? this.labels.save+' '+this.format.format((before-after)/100)+' (20%)' : this.labels.incomplete;
      this.submitButton.disabled = count!==3 || this.busy;
    }
    async addBundle() {
      if (this.busy || this.picks.size!==3) return;
      this.busy = true; this.submitButton.disabled = true;
      this.submitButton.setAttribute('aria-busy','true');
      this.status.textContent = this.labels.adding;
      this.querySelectorAll('select,[data-pick],[data-remove]').forEach(el=>{el.dataset.wasDisabled=String(el.disabled);el.disabled=true;});
      try {
        const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...this.picks.values()].map(item=>({id:item.id,quantity:1}))})});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.labels.error);
        window.location.assign(this.dataset.cartUrl);
      } catch(error) {
        this.status.textContent = error.message || this.labels.error;
        this.busy=false;
        this.querySelectorAll('[data-was-disabled]').forEach(el=>{el.disabled=el.dataset.wasDisabled==='true';delete el.dataset.wasDisabled;});
        this.submitButton.removeAttribute('aria-busy'); this.render();
      }
    }
  });
}
